export const pathRoutes = {
    WALLET_MANAGER: '/popup/wallet/manage',
    WALLET_DETAILS: '/popup/wallet/details',
}

export const iconTokens = {
    BNB: '/assets/img/BNB.svg',
    SING: '/assets/img/SING.svg',
    BUSD: '/assets/img/BUSD.svg',
    ES: '/assets/img/ESING.svg',
}

export const iconButtons = {
    TRANSFER: '/assets/img/transfer.svg',
    RECEIVE: '/assets/img/receiver.svg',
    COPY: '/assets/img/copy.svg',
    MORE: '/assets/img/more.svg',
}

export const walletStepEnum = {
    WALLET_LIST: 0,
    WALLET_DETAILS: 1,
    SELECT_TOKEN: 2,
    SEND_TOKEN: 3,
    SEND_TOKEN_CONFIRM: 4,
    SEND_TOKEN_RESULT: 5,
    RECEIVE_TOKEN: 6,
    TOKEN_DETAILS: 7,
}

export const tokenActionTypeEnum = {
    SEND: 1,
    RECEIVE: 2,
}

export const DEFAULT_WALLET_SYMBOL = 'BNB';

export const FERNET_KEY = process.env.REACT_APP_FERNET_KEY || '1uGX19pSBdrnSiF7jaIXqjQjPEsDCJ9CnXwlMSkEAY8=';

export const urlScan ={
    97: 'https://testnet.bscscan.com/',
    56: 'https://bscscan.com'
}